// Pages that do not require user authentication
const PUBLIC_PAGES = [
  '/login',
  '/register',
  '/reset-password',
  '/change-password',
  '/forbidden',
  '/service-unavailable',
  '/activation-pending',
  '/verify-email',
  '/newsletter/unsubscribe',
  '/accept-invitation',
] as const;

export const isPublic = (path: string): boolean => {
  return PUBLIC_PAGES.includes(path as (typeof PUBLIC_PAGES)[number]);
};

export const requiresAuth = (path: string): boolean => {
  return !isPublic(path);
};
